import * as React from 'react';
import { useSelector } from 'react-redux';

import { EstimationChartLogicContainer } from '../EstimationChartLogicContainer';
import { selectEstimationChartState } from '../../../../selectors/estimationChart';
import { defaultRefWrapper, TRefWrapper } from '../../../Scrolling';

interface IEstimationChartContainerProps {
  refWrapper: TRefWrapper;
}

export function EstimationChartContainer({ refWrapper }: IEstimationChartContainerProps) {
  const { isError, data } = useSelector(selectEstimationChartState);

  if (isError || !data) {
    return null;
  }

  return <EstimationChartLogicContainer refWrapper={refWrapper} />;
}

EstimationChartContainer.defaultProps = {
  refWrapper: defaultRefWrapper,
};
